/*
 * Author: Danny Ehlers
 * Date: 8/16/2018
 * This service is used for starting and stopping the spinner.
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CapSpinnerService {

  spinnerVisible: boolean = false;

  spinnerShow() {
    this.spinnerVisible = true;
  }

  spinnerHide() {
    this.spinnerVisible = false;
  }
}
